<!-- 详情页的图片展示 -->
<template>
  <div class="c-media-show">
    <template v-if="showType == 'default'">
      <!-- 左侧大图部分 -->
      <div class="bigphoto"
        :class="{
          'bigphoto--left': galleryPosition === 'gallery_left'
        }"
      >
        <div class="bigphoto__card-wrapper">
          <product-tag
            v-if="productTagList[product.ID]"
            :productTag="productTagList[product.ID]"
            :productInfo="{
              ...productInfo,
              stock: variantNew.stock,
              sku: variantNew.sku,
            }"
          />
          <media-card
            :type="bigImg.media_content_type"
            :url="bigImg.url"
            :thumbnail="bigImg.thumbnail"
            :src="bigImg.url"
            :autoplay="true"
            :muted="true"
          />
        </div>

        <template v-if="gallery.length > 1">
          <!-- 缩略图在下, 小屏三列，宽屏4列 -->
          <div class="row smallimg" v-if="galleryPosition === 'gallery_bottom'">
            <div class="col-md-3 col-4 smallimg__item" v-for="(item, index) in gallery" :key="item.ID">
              <div
                class="smallimg__wrapper"
                :class="{
                  active: activeIndex === index,
                  'image-radius': themeStyleRadius == 'circle',
                }"
                @click="() => handleClick(index)"
              >
                <i
                  v-if="item.media_content_type === 'video' || item.media_content_type === 'external_video'"
                  class="smallimg__video-icon"
                  :class="{
                    'el-icon-video-play': item.media_content_type === 'video',
                    'iconfont icon-cm-youtube': item.media_content_type === 'external_video',
                  }"
                ></i>
                <v-lazy-img :data-url="item.url" :src="item.thumbnail" :data-src="item.thumbnail" />
              </div>
            </div>
          </div>

          <!-- 缩略图居左 -->
          <div class="smallimg" v-else>
            <vertical-pagination
              class="smallimg__pagination"
              :data="gallery"
              :activeIndex="activeIndex"
              @change="handleClick"
            />
          </div>
        </template>
      </div>
    </template>

    <!-- 左侧图片平铺展示 -->
    <div class="bigphoto bigphoto--tile" v-else>
      <template v-for="(item, index) in gallery">
        <div class="bigphoto__card-wrapper" :key="index">
          <!-- 插件: 产品标签 -->
          <!-- 平铺时，仅第一张图片显示 -->
          <product-tag
            v-if="productTagList[product.ID] && index === 0"
            :productTag="productTagList[product.ID]"
            :productInfo="{ ...productInfo, stock: variantNew.stock, sku: variantNew.sku }"
          />
          <!-- 媒体卡片 -->
          <media-card
            :src="item.url"
            :url="item.url"
            :thumbnail="item.thumbnail"
            :type="item.media_content_type"
            :autoplay="false"
            :muted="false"
            class="bigphoto__media"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
//import LazyImg from '../LazyImg.vue'
import MediaCard from '../MediaCard.vue'
import VerticalPagination from '../ProductSwiper/VerticalPagination.vue'
import productTag from '../view/productTag/productTag.vue'

export default {
  name: 'mediaShow',
  components: {
    productTag,
    MediaCard,
    //LazyImg,
    VerticalPagination,
  },
  emits: ['selected'],
  props: {
    product: {
      type: Object,
      Request: true,
    },
    bigImg: {
      type: Object,
      default: {},
    },
    productInfo: {
      type: Object,
      default: {},
    },
    variantNew: {
      type: Object,
      default: {},
    },
    galleryConfig: {
      type: Object,
      default: {},
    },
    gallery: {
      type: Array,
      default: [],
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showType: this.galleryConfig?.gallery_show_config || 'default',
      galleryPosition: this.galleryConfig?.gallery_postion || 'gallery_bottom',
    }
  },
  computed: {
    ...mapState({
      productTagList: (state) => state.product_tag_list,
      themeStyleRadius: ({ options }) => options?.theme?.global?.style?.type || '',
    }),
    activeImg() {
      return this.gallery?.[this.activeIndex] || {}
    },
  },
  methods: {
    handleClick(index) {
      this.$emit('selected', index)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-media-show {
  .bigphoto {
    max-width: 100vw;
    img {
      max-width: 100%;
      max-height: 570px;
      width: 100%;
      object-fit: contain;
    }
    // 解决因width,height设置为100%时border-radius不生效
    .image--radius {
      width: auto !important;
      height: auto !important;
    }

    &__card-wrapper {
      position: relative;
    }
    // 平铺
    &--tile {
      .bigphoto {
        &__card-wrapper {
          margin-bottom: 20px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    // 小图居左
    &--left {
      display: flex;
      flex-direction: row-reverse;
      flex-wrap: wrap;
      .smallimg {
          width: 78px;
          margin: 0;
          margin-right: 12px;
          position: relative;
          &__pagination {
            position: absolute;
            height: 100%;
            min-height: unset;
            ::v-deep {
              .slide-item {
                margin-bottom: 12px;
                height: 78px;
                background-color: #ebebeb;
                img {
                  height: 100%;
                  width: 100%;
                  object-fit: contain;
                }
                &.active {
                  &::before {
                    border-width: 1px;
                  }
                }
              }
            }
          }
      }
      .bigphoto {
        &__card-wrapper {
          flex: 1;
        }
      }
    }
  }

  // 缩略图
  .smallimg {
    margin: -10px;
    margin-top: 10px;
    &__item {
      padding: 10px;
    }
    &__wrapper {
      height: 0px;
      width: 100%;
      padding-bottom: 100%;
      background-color: #ebebeb;
      cursor: pointer;
      position: relative;
      transition: all 0.2s;
      img {
        position: absolute;
        height: 100%;
        width: 100%;
        object-fit: contain;
      }
      &.active {
        &::before {
          position: absolute;
          border: 1px solid var(--main-btn-bg);
          z-index: 3;
          content: '';
          width: 100%;
          height: 100%;
          top: 0;
        }
        // cursor: pointer;
      }
    }
    &__video-icon {
      position: absolute;
      z-index: 2;
      font-size: 30px;
      color: #fff;
      height: 100%;
      width: 100%;
      background: #00000035;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>